import React from "react";
import { Calendar, Phone } from "lucide-react";
import { useBooking } from "@/lib/booking";
import { business } from "@/data/site";

export const StickyMobileCTA = () => {
  const { openBooking } = useBooking();
  return (
    <div className="fixed inset-x-0 bottom-0 z-50 md:hidden">
      <div className="glass grid grid-cols-2 gap-2 border-t border-[var(--border)] p-3 pb-[max(0.75rem,env(safe-area-inset-bottom))]">
        <button
          onClick={() => openBooking()}
          data-testid="sticky-book-btn"
          className="flex items-center justify-center gap-2 rounded-full bg-[var(--primary)] py-3.5 text-sm font-medium text-[var(--on-primary)] active:scale-[0.97]"
        >
          <Calendar size={17} /> Book Now
        </button>
        <a
          href={business.phoneHref}
          data-testid="sticky-call-btn"
          className="flex items-center justify-center gap-2 rounded-full border border-[var(--fg)]/20 py-3.5 text-sm font-medium text-[var(--fg)] active:scale-[0.97]"
        >
          <Phone size={17} /> Call / Text
        </a>
      </div>
    </div>
  );
};
